import { useTranslation } from "react-i18next";

const STEP_KEYS = ["processing", "shipping", "delivered"];
const CANCELLED_STEP_KEYS = ["processing", "cancelled"];

const OrderStatusTimeline = ({ current }) => {
    const { t } = useTranslation();
    const isCancelled = current === "cancelled";
    const steps = (isCancelled ? CANCELLED_STEP_KEYS : STEP_KEYS).map((key) => ({
        key,
        label: t(`ORDER_STATUS_${key.toUpperCase()}`),
        red: key === "cancelled",
    }));

    const currentIndex = steps.findIndex((step) => step.key === current);
    const n = steps.length;
    const progressPercent =
        currentIndex < 0 ? 0 : ((currentIndex + 1) / n) * 100;

    const getDotClass = (step, isActive) => {
        if (isActive && step.red) return "border-red-500";
        if (isActive) return "border-primary";
        return "border-slate-300";
    };

    const getLabelClass = (step, isActive) => {
        if (isActive && step.red) return "font-medium text-red-500";
        if (isActive) return "font-medium text-primary";
        return "text-slate-400";
    };

    return (
        <div className="mt-8">
            <p className="text-sm font-semibold text-slate-900">{t("GIFT_ORDER_STATUS_TITLE")}</p>

            <div className="mt-6 hidden md:block">
                <div className="relative pb-8">
                    <div className="absolute left-0 right-0 top-[10px] h-[2px] bg-slate-200" />
                    {currentIndex >= 0 && !isCancelled && (
                        <div
                            className="absolute left-0 top-[10px] h-[2px] bg-primary"
                            style={{ width: `${progressPercent}%` }}
                        />
                    )}
                    {isCancelled && (
                        <>
                            <div className="absolute left-0 top-[10px] h-[2px] bg-primary" style={{ width: "50%" }} />
                            <div className="absolute top-[10px] h-[2px] bg-red-500" style={{ left: "50%", width: "50%" }} />
                        </>
                    )}
                    <div className="relative z-10 flex justify-around">
                        {steps.map((step, index) => {
                            const isActive = index <= currentIndex;
                            return (
                                <div key={step.key} className="relative flex-shrink-0">
                                    <div
                                        className={`h-5 w-5 rounded-full border-[6px] bg-white ${getDotClass(step, isActive)}`}
                                    />
                                    <span
                                        className={`absolute left-1/2 top-full mt-3 -translate-x-1/2 whitespace-nowrap text-xs ${getLabelClass(step, isActive)}`}
                                    >
                                        {step.label}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className="mt-4 md:hidden">
                {steps.map((step, index) => {
                    const isActive = index <= currentIndex;
                    return (
                        <div key={step.key} className="flex items-start gap-4">
                            <div className="flex flex-col items-center">
                                <div
                                    className={`h-5 w-5 rounded-full border-[6px] bg-white ${getDotClass(step, isActive)}`}
                                />
                                {index < steps.length - 1 && (
                                    <div
                                        className={`h-8 w-[2px] ${
                                            index < currentIndex ? "bg-primary" : "bg-slate-200"
                                        }`}
                                    />
                                )}
                            </div>
                            <span className={`mt-1 text-xs ${getLabelClass(step, isActive)}`}>
                                {step.label}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OrderStatusTimeline;
